import { giphyBlack } from '@giphy/colors'
import styled, { css } from 'styled-components'
import { ControlSize } from 'types'
import {
    borderRadiusFromControlSize,
    brightnessFromColor,
    fontShadowFromControlSize,
    fontSizeFromControlSize,
    heightFromControlSize,
} from 'utils'
import BackgroundComponent from './background'
import SliderComponent from './dnd'

export const Background = styled(BackgroundComponent)`
    left: 0;
    position: absolute;
    top: 0;
`

export const Children = styled.div`
    align-items: center;
    display: flex;
    flex-direction: row;
    height: 100%;
    width: 100%;
`

export const Container = styled.div<{
    backgroundColor: string
    controlColor?: string
    controlSize: ControlSize
    hasTextShadow: boolean
    textColor?: string
}>`
    font-weight: bold;
    overflow: hidden;
    position: relative;

    ${({ backgroundColor, controlColor, controlSize, hasTextShadow, textColor }) => {
        let color = textColor || '#fff'

        if (!textColor && controlColor) {
            color = brightnessFromColor(controlColor) > 0.5 ? giphyBlack : '#fff'
        }

        return css`
            background: ${backgroundColor};
            border-radius: ${borderRadiusFromControlSize(controlSize)}px;
            color: ${color};
            font-size: ${fontSizeFromControlSize(controlSize)}px;
            height: ${heightFromControlSize(controlSize)}px;

            ${hasTextShadow &&
            css`
                ${Children} {
                    filter: drop-shadow(${fontShadowFromControlSize(controlSize)});
                }
            `}
        `
    }}
`

export const Slider = styled(SliderComponent)<{ backgroundColor: string }>`
    bottom: 0;
    box-shadow: 0 0 0 9999px ${({ backgroundColor }) => backgroundColor};
    position: absolute;
    top: 0;
`
